import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function () {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(s, firstScript);
  } else {
    document.head.appendChild(s);
  }
  w.fbq('init', '1934048370513297');
  w.fbq('track', 'PageView');
})();
render(<App data-id="element-328" />, document.getElementById('root'));